/**
 * Ručno uneseni noćni sati po osobi i kalendarskom mjesecu (ne ulaze u zbrojeve metrika).
 * Doc ID: `${userId}_${year}_${month}`
 */

export function monthlyNightHoursDocId(userId, year, month) {
  return `${userId}_${year}_${month}`;
}

/** Parsira unos (decimalni sati); prazan string -> 0; nevaljano -> null */
export function parseDecimalHoursInput(raw) {
  if (raw == null) return 0;
  const s = String(raw).trim();
  if (s === '') return 0;
  const n = parseFloat(s.replace(',', '.'));
  if (Number.isNaN(n) || n < 0) return null;
  return n;
}
